import React from "react";
import { useTranslation } from "react-i18next";
import houseImg from "assets/ServerError.svg";
import NavBar from "../../components/layouts/NavBar";
import Footer from "../../components/layouts/Footer";

const NotFound = (props) => {
  const { t } = useTranslation();

  const { error } = props || { error: { message: "Unknown error" } };

  return (
    <div className="App">
      <NavBar />
      <div className="d-flex justify-content-center my-5 text-center">
        <div className="d-flex flex-column">
          <h4 className="text-secondary">{t("server_error1")}..</h4>
          <div className="my-4">
            <img src={houseImg} width={300} alt="not found image" />
          </div>
          {error &&
            (process.env.NODE_ENV === "development" ? (
              <div>
                Reason: <pre style={{ color: "red" }}>{error?.message} </pre>
              </div>
            ) : (
              ""
            ))}
          <div>
            <label className="pt-3 w-50 text-secondary">
              {t("server_error2")} <br />
              <label
                className="text-decoration-underline link-cstm btn"
                onClick={() => window.location.reload()}
              >
                {t("try-again")}
              </label>
            </label>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
